import React from "react";
import { CONTACTS } from "../mock/mockData";

export function SiteFooter({ lang }) {
  const year = new Date().getFullYear();
  const { copyright } = CONTACTS;

  return (
    <footer className="border-t border-slate-300 bg-[#041e41] py-5 text-xs text-slate-100">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-2 px-4 md:flex-row md:px-6">
        <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.18em]">
          <span>© {year} Strategic Lobbying Alliance</span>
        </div>
        <div className="text-[11px] uppercase tracking-[0.18em]">
          {copyright[lang]}
        </div>
      </div>
    </footer>
  );
}
